import React, { useState, useEffect } from "react";
import { FaFilter } from "react-icons/fa";
import { getVerticals } from "../../../api/offers";
import { UserFilterDefaultsUpdate } from "../../../models/usersFilters";

interface UpdateFiltersModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (filters: UserFilterDefaultsUpdate) => void;
    email?: string;
    initialFilters?: UserFilterDefaultsUpdate;
}


//note state logic is commented out to exclude it, but its functional

const campaignOptions = ["Calls", "Leads", "Traffic"];

// const US_STATES = [
//     "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
//     "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
//     "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
//     "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
//     "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
//     "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
//     "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
//     "Wisconsin", "Wyoming"
// ];

export default function UpdateFiltersModal({
    isOpen,
    onClose,
    onConfirm,
    email,
    initialFilters = { email: "", verticals: [], state_list: [] },
}: UpdateFiltersModalProps) {
    const [verticalOptions, setVerticalOptions] = useState<string[]>([]);
    const [filters, setFilters] = useState<UserFilterDefaultsUpdate>({
        email: initialFilters.email || "",
        verticals: initialFilters.verticals || [],
        state_list: initialFilters.state_list || [],
        min_duration: initialFilters.min_duration ?? undefined,
        max_duration: initialFilters.max_duration ?? undefined,
        min_payout: initialFilters.min_payout ?? undefined,
        max_payout: initialFilters.max_payout ?? undefined,
        payout_type: initialFilters.payout_type ?? null,
        call_type_flex: initialFilters.call_type_flex ?? null,
        campaign_types: initialFilters.campaign_types || [],
    });

    useEffect(() => {
        if (isOpen) {
            setFilters({
                email: initialFilters.email || "",
                verticals: initialFilters.verticals || [],
                state_list: initialFilters.state_list || [],
                min_duration: initialFilters.min_duration ?? undefined,
                max_duration: initialFilters.max_duration ?? undefined,
                min_payout: initialFilters.min_payout ?? undefined,
                max_payout: initialFilters.max_payout ?? undefined,
                payout_type: initialFilters.payout_type ?? null,
                call_type_flex: initialFilters.call_type_flex ?? null,
                campaign_types: initialFilters.campaign_types || [],
                
            });
        }
    }, [isOpen, initialFilters]);

    useEffect(() => {
        const fetchVerticals = async () => {
            try {
                const data = await getVerticals();
                setVerticalOptions(data);
            } catch (error) {
                console.error("Failed to fetch verticals:", error);
            }
        };
        fetchVerticals();
    }, []);

    if (!isOpen) return null;

    const allVerticalsSelected = filters.verticals?.length === verticalOptions.length;
    // const allStatesSelected = filters.state_list?.includes("Nationwide");

    const toggleVertical = (value: string) => {
        if (value === "all") {
            setFilters((prev) => ({
                ...prev,
                verticals: allVerticalsSelected ? [] : [...verticalOptions],
            }));
        } else {
            setFilters((prev) => {
                const updated = prev.verticals?.includes(value)
                    ? prev.verticals.filter((v) => v !== value)
                    : [...(prev.verticals || []), value];
                return { ...prev, verticals: updated };
            });
        }
    };

    // const toggleState = (value: string) => {
    //     if (value === "Nationwide") {
    //         setFilters((prev) => ({
    //             ...prev,
    //             state_list: allStatesSelected ? [] : ["Nationwide"],
    //         }));
    //     } else {
    //         setFilters((prev) => {
    //             let updated: string[];
    //             if (prev.state_list?.includes("Nationwide")) {
    //                 updated = [value];
    //             } else {
    //                 updated = prev.state_list?.includes(value)
    //                     ? prev.state_list.filter((s) => s !== value)
    //                     : [...(prev.state_list || []), value];
    //             }
    //             return { ...prev, state_list: updated };
    //         });
    //     }
    // };

    const handleConfirm = () => {
        onConfirm(filters);
        onClose();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
            <div className="relative bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-6 w-full max-w-lg shadow-lg overflow-y-auto max-h-[90vh]">
                <div className="flex items-center gap-3 mb-4">
                    <FaFilter className="text-blue-500 text-2xl" />
                    <h2 className="text-xl font-semibold">Update Filters</h2>
                </div>

                <p className="mb-4 text-gray-600 dark:text-gray-300">
                    Updating filters for <span className="font-medium">{email ?? "this user"}</span>.
                </p>

                <div className="space-y-4">
                    <div>
                        <label className="block mb-1 font-medium">Verticals</label>
                        <div className="border rounded p-2 max-h-40 overflow-y-auto bg-white dark:bg-gray-700">
                            <label className="flex items-center gap-2 mb-1 cursor-pointer font-semibold">
                                <input
                                    type="checkbox"
                                    checked={allVerticalsSelected}
                                    onChange={() => toggleVertical("all")}
                                    className="accent-blue-500"
                                />
                                <span className="text-gray-900 dark:text-gray-100">Select All</span>
                            </label>
                            {verticalOptions.map((v) => (
                                <label key={v} className="flex items-center gap-2 mb-1 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={filters.verticals?.includes(v)}
                                        onChange={() => toggleVertical(v)}
                                        className="accent-blue-500"
                                    />
                                    <span className="text-gray-900 dark:text-gray-100">{v}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* <div>
                        <label className="block mb-1 font-medium">States</label>
                        <div className="border rounded p-2 max-h-40 overflow-y-auto bg-white dark:bg-gray-700">
                            <label className="flex items-center gap-2 mb-1 cursor-pointer font-semibold">
                                <input
                                    type="checkbox"
                                    checked={allStatesSelected}
                                    onChange={() => toggleState("Nationwide")}
                                    className="accent-blue-500"
                                />
                                <span className="text-gray-900 dark:text-gray-100">Nationwide</span>
                            </label>
                            {US_STATES.map((state) => (
                                <label key={state} className="flex items-center gap-2 mb-1 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={filters.state_list?.includes(state)}
                                        onChange={() => toggleState(state)}
                                        className="accent-blue-500"
                                    />
                                    <span className="text-gray-900 dark:text-gray-100">{state}</span>
                                </label>
                            ))}
                        </div>
                    </div> */}

                    <div className="grid grid-cols-2 gap-3">
                        <input
                            type="number"
                            placeholder="Min Duration"
                            value={filters.min_duration ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    min_duration: e.target.value === "" ? null : +e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        />
                        <input
                            type="number"
                            placeholder="Max Duration"
                            value={filters.max_duration ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    max_duration: e.target.value === "" ? null : +e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <input
                            type="number"
                            placeholder="Min Payout"
                            value={filters.min_payout ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    min_payout: e.target.value === "" ? null : +e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        />
                        <input
                            type="number"
                            placeholder="Max Payout"
                            value={filters.max_payout ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    max_payout: e.target.value === "" ? null : +e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Payout Type</label>
                        <select
                            value={filters.payout_type ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    payout_type: e.target.value === "" ? null : e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        >
                            <option value="">Any</option>
                            <option value="fixed">Fixed</option>
                            <option value="variable">Variable</option>
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Call Type (Flex)</label>
                        <select
                            value={filters.call_type_flex ?? ""}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    call_type_flex: e.target.value === "" ? null : e.target.value,
                                }))
                            }
                            className="px-3 py-2 border rounded-lg bg-gray-50 dark:bg-gray-700 w-full"
                        >
                            <option value="">Any</option>
                            <option value="fixed">Fixed</option>
                            <option value="variable">Variable</option>
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Campaign Types</label>
                        <div className="border rounded p-2 max-h-40 overflow-y-auto bg-white dark:bg-gray-700">
                            <label className="flex items-center gap-2 mb-1 cursor-pointer font-semibold">
                                <input
                                    type="checkbox"
                                    checked={filters.campaign_types?.length === campaignOptions.length}
                                    onChange={() =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            campaign_types:
                                                prev.campaign_types?.length === campaignOptions.length
                                                    ? []
                                                    : [...campaignOptions],
                                        }))
                                    }
                                    className="accent-blue-500"
                                />
                                <span className="text-gray-900 dark:text-gray-100">Select All</span>
                            </label>
                            {campaignOptions.map((c) => (
                                <label key={c} className="flex items-center gap-2 mb-1 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={filters.campaign_types?.includes(c)}
                                        onChange={() =>
                                            setFilters((prev) => {
                                                const updated = prev.campaign_types?.includes(c)
                                                    ? prev.campaign_types.filter((v) => v !== c)
                                                    : [...(prev.campaign_types || []), c];
                                                return { ...prev, campaign_types: updated };
                                            })
                                        }
                                        className="accent-blue-500"
                                    />
                                    <span className="text-gray-900 dark:text-gray-100">{c}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors"
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
}
